export default {
  // Navigation
  'nav.home': 'Home',
  'nav.spreadsheet': 'Spreadsheet',
  'nav.categories': 'Categories',
  'nav.guides': 'Guides',
  'nav.reviews': 'Reviews',
  'nav.shipping': 'Shipping',
  'nav.safety': 'Safety',
  'nav.shoppingGuide': 'Shopping Guide',

  // Page headers
  'page.spreadsheet.title': 'AllChinaBuy Spreadsheet Categories',
  'page.spreadsheet.subtitle': 'Browse every category in the AllChinaBuy Spreadsheet and jump straight to the products you need.',
  'page.guides.title': 'AllChinaBuy Guides & Articles',
  'page.guides.subtitle': 'Original, practical guides covering QC, shipping, safety and buying tips.',
  'page.reviews.title': 'AllChinaBuy Reviews & Independent Research',
  'page.reviews.subtitle': 'Honest, independent insights to help you evaluate AllChinaBuy before you order.',
  'page.safety.title': 'AllChinaBuy Safety Guide',
  'page.safety.subtitle': 'A practical checklist to verify information and reduce common buying risks.',

  // Hero
  'hero.badge': 'Independent resource · Regularly reviewed',
  'hero.title': 'AllChinaBuy Spreadsheet — Find, Compare & Shop Smarter',
  'hero.subtitle': 'Explore organized product finds, category guides, QC information, shipping resources and practical buying tips in one place. Whether you are new to AllChinaBuy or an experienced buyer, this resource helps you research products, compare options and make better-informed decisions before ordering.',
  'hero.searchPlaceholder': 'Search products, categories, sellers or guides…',
  'hero.ctaPrimary': 'Explore the Spreadsheet',
  'hero.ctaSecondary': 'Buy It Now',
  'hero.trustLine': 'Independent resource · Useful guides · Regularly reviewed',

  // Category
  'category.title': 'Browse by Category',
  'category.subtitle': 'Jump straight to the category you need on the main website.',
  'category.dropdownLabel': 'Choose a category',
  'category.dropdownPlaceholder': 'Select a category…',
  'category.viewAll': 'Browse All Categories',
  'category.note': 'Information may change. Verify product and seller details before ordering.',

  // Category names
  'cat.shoes': 'Shoes',
  'cat.hoodies': 'Hoodies / Sweaters',
  'cat.tshirts': 'T-Shirts',
  'cat.jackets': 'Jackets',
  'cat.pants': 'Pants / Shorts',
  'cat.headwear': 'Headwear',
  'cat.sets': 'Sets',
  'cat.underwear': 'Underwear / Underpants',
  'cat.jersey': 'Jersey',
  'cat.accessories': 'Accessories',
  'cat.bags': 'Bags',
  'cat.belts': 'Belts',
  'cat.perfumes': 'Perfumes',
  'cat.other': 'Other Stuff',

  // About / intro text
  'about.title': 'Everything You Need for AllChinaBuy Research',
  'about.subtitle': 'A clear, honest starting point for understanding the AllChinaBuy Spreadsheet and how to use it.',
  'about.paragraph1': 'The AllChinaBuy Spreadsheet is a community-organized collection of product links, categories and buying resources. It gathers finds across shoes, clothing, bags, accessories and more, so you can browse what you need without hunting through scattered links.',
  'about.paragraph2': 'This website is an independent informational resource. It is not the official AllChinaBuy website and is not affiliated with it. We explain how the spreadsheet works, how to evaluate products, and how to research shipping and QC before you order.',

  // Feature cards
  'feature.spreadsheet.title': 'AllChinaBuy Spreadsheet',
  'feature.spreadsheet.desc': 'Browse organized product finds and category resources.',
  'feature.qc.title': 'QC Guides',
  'feature.qc.desc': 'Learn how to understand product photos, quality details and sizing.',
  'feature.shipping.title': 'Shipping',
  'feature.shipping.desc': 'Understand shipping options, costs, weight and common mistakes.',
  'feature.reviews.title': 'Reviews',
  'feature.reviews.desc': 'Read independent research and practical AllChinaBuy reviews.',
  'feature.safety.title': 'Safety',
  'feature.safety.desc': 'Learn how to verify information and reduce common buying risks.',
  'feature.comparisons.title': 'Comparisons',
  'feature.comparisons.desc': 'Compare AllChinaBuy with other popular buying platforms.',

  // Beginner
  'beginner.title': 'New to AllChinaBuy?',
  'beginner.desc': 'Start with our beginner guide to learn how the spreadsheet works, how to evaluate products, understand QC photos and research shipping before ordering.',
  'beginner.cta': 'Read the Beginner Guide',

  // Research note
  'research.title': 'Research Before You Buy',
  'research.desc': 'Product links, prices, sellers and shipping conditions can change. Use this website as a research resource and verify current information before purchasing.',
  'research.cta': 'Read the Safety Guide',

  // Guides / articles
  'guides.title': 'Latest Guides & Articles',
  'guides.subtitle': 'Original, practical guides to help you research smarter.',
  'guides.readMore': 'Read Article',
  'guides.article1.title': 'How to Use the AllChinaBuy Spreadsheet: A Complete Beginner Guide',
  'guides.article1.desc': 'Learn what the AllChinaBuy Spreadsheet is, how it is organized, and how to browse categories and verify products before you order.',
  'guides.article1.meta': 'A beginner-friendly guide to the AllChinaBuy Spreadsheet covering how it works, category browsing, product research and safety tips.',

  // FAQ
  'faq.title': 'Frequently Asked Questions',
  'faq.subtitle': 'Quick answers to common questions about the AllChinaBuy Spreadsheet.',
  'faq.q1': 'Is this the official AllChinaBuy website?',
  'faq.a1': 'No. This is an independent informational resource about the AllChinaBuy Spreadsheet. We are not affiliated with AllChinaBuy and do not represent the official platform.',
  'faq.q2': 'What is the AllChinaBuy Spreadsheet?',
  'faq.a2': 'It is a community-organized collection of product links and categories. It helps buyers find items across shoes, clothing, bags and accessories in one convenient place.',
  'faq.q3': 'Do prices and links change?',
  'faq.a3': 'Yes. Product links, prices, sellers and shipping conditions can change at any time. Always verify current information on the product page before purchasing.',
  'faq.q4': 'Where do the category buttons lead?',
  'faq.a4': 'The category buttons and dropdown link to the main website so you can browse the corresponding product category there.',

  // Final CTA
  'final.title': 'Ready to Explore the AllChinaBuy Spreadsheet?',
  'final.desc': 'Browse the latest resources, compare categories and continue to the main website when you are ready.',
  'final.cta': 'Explore AllChinaBuy Resources',

  // Footer
  'footer.tagline': 'An independent informational resource about the AllChinaBuy Spreadsheet.',
  'footer.disclaimer': 'This website is an independent informational resource and is not the official AllChinaBuy website. Product availability, prices, links, sellers, shipping options and promotional offers may change. Always verify current information before purchasing.',
  'footer.resources': 'Resources',
  'footer.categories': 'Categories',
  'footer.legal': 'Legal',
  'footer.home': 'Home',
  'footer.privacy': 'Privacy',
  'footer.terms': 'Terms',
  'footer.disclaimerLink': 'Disclaimer',
  'footer.rights': 'All rights reserved.',

  // Language
  'lang.en': 'English',
  'lang.fr': 'Français',
  'lang.da': 'Dansk',
  'lang.de': 'Deutsch',

  // Article page
  'article.backHome': 'Back to Home',
  'article.breadcrumbHome': 'Home',
  'article.breadcrumbGuides': 'Guides',
  'article.updated': 'Last updated',
  'article.readingTime': 'min read',
  'article.keyTakeaways': 'Key takeaways',
  'article.notFound': 'Article not found',
};